import React from "react";
import InfoRows from "./InfoRows";

function SkeletonRows() {
  return (
    <div className="new-merchant-information__skeleton">
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="new-merchant-information__skeleton-row" key={index}>
          <span />
          <span />
        </div>
      ))}
    </div>
  );
}

export default function LegalDetailsPanel({ loading = false, entity = {} }) {
  return (
    <section className="new-merchant-information__section-card">
      <div className="new-merchant-information__section-head">
        <div>
          <span className="new-merchant-information__eyebrow">Entity</span>
          <h3>Legal Information</h3>
          <p>Reference information for the legal account behind your merchant setup.</p>
        </div>
      </div>

      {loading ? <SkeletonRows /> : <InfoRows data={entity} />}
    </section>
  );
}
